<template>
  <div class="row billing-section">
    <div id="payments-table" class="col-md-12 materialized">
      <vue-good-table
        :columns="columns"
        :rows="eftAgreements"
        styleClass="table condensed table-hover"
        sortable=true>
        <template slot="custom-columns" slot-scope="props">
          <th :class="props.columnHeaderClass(columns[0], 0).replace('sorting', '')"
              :style="{width: columns[0].width ? columns[0].width : 'auto'}"
              v-if="!columns[0].hidden">
                <el-checkbox role="button" id="select-all-agreements" v-model="selectAll"></el-checkbox>
          </th>
          <th v-for="(column, index) in props.columns.slice(-props.columns.length + 1)"
              @click="props.sort(index + 1)"
              :class="props.columnHeaderClass(column, index + 1)"
              :style="{width: column.width ? column.width : 'auto'}"
              v-if="!column.hidden">
            <span>{{column.label}}</span>
          </th>
        </template>
        <template slot="table-row" slot-scope="props">
          <td class="text-center materialized" data-title=''>
            <el-checkbox role="button" @change="value => addAgreement(value, props.row.agreementId  )"
                         :value="selectedAgreements.indexOf(props.row.agreementId) > -1"></el-checkbox>
          </td>
          <td class="text-center" data-title='Member'><span class="data-item">{{ props.row.memberName }}</span>
          </td>
          <td class="text-center" data-title='Agreement'>
            <span class="data-item">{{ props.row.agreementId}}</span>
            <br>
            <span class="data-item">{{ '(' + props.row.agreementType + ')' }}</span>
          </td>
          <td class="text-center" data-title='Club of Purchase'>
            <span class="data-item">{{ props.row.clubPurchase }}</span>
          </td>
          <td class="text-center" data-title='Next Debit Date'>
            <span class="data-item">{{ props.row.renewal }}</span>
          </td>
          <td class="text-center" data-title='Recurring Dues'>
            <span class="data-item">{{ '$' + props.row.recurringDues.toFixed(2) }}</span>
          </td>
          <td class="text-center" data-title='Auto-Billed'>
            <template v-if="props.row.accountType === 'MC'">
              <i class="cc-sprite mc-cc-color"
                 :class="{'overdue-card' : new Date(props.row.cardExpirationDate) < new Date()}"></i>
            </template>
            <template v-else-if="props.row.accountType === 'VISA'">
              <i class="cc-sprite visa-cc-color"
                 :class="{'overdue-card' : new Date(props.row.cardExpirationDate) < new Date()}"></i>
            </template>
            <template v-else-if="props.row.accountType === 'AMX'">
              <i class="cc-sprite amx-cc-color"
                 :class="{'overdue-card' : new Date(props.row.cardExpirationDate) < new Date()}"></i>
            </template>
            <template v-else-if="props.row.accountType === 'DIS'">
              <i class="cc-sprite dis-cc-color"
                 :class="{'overdue-card' : new Date(props.row.cardExpirationDate) < new Date()}"></i>
            </template>
            <template v-else>
              <i class="fa fa-university fa-lg"></i>
            </template>
            <br>
            <span class="data-item" :class="{'overdue-card' :
            !(props.row.accountType === 'SAV' || props.row.accountType === 'CHK')
            && new Date(props.row.cardExpirationDate) < new Date()}">
              {{ props.row.autoBilled }}
            </span>
            <br>
            <template v-if="props.row.cardExpirationDate">
                <span class="data-item"
                      :class="{'overdue-card' : new Date(props.row.cardExpirationDate) < new Date()}">(Exp. {{ ('0' + (new Date(props.row.cardExpirationDate).getMonth() + 1)).slice(-2)
                  }}/{{new Date(props.row.cardExpirationDate).getFullYear().toString().substr(-2)}})</span>
            </template>
          </td>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { StringUtils } from 'my-account-common'

  export default {
    name: 'PaymentTable',
    props: {
      agreementData: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        message: 'Payment Methods',
        selectedAgreements: [],
        columns: [
          {
            label: '',
            field: 'selected',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Member',
            field: 'memberName',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Agreement',
            field: 'agreementId',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Club of Purchase',
            field: 'clubPurchase',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Next Debit Date',
            field: 'renewal',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Recurring Dues',
            field: 'recurringDues',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Payment Method',
            field: 'autoBilled',
            tdClass: 'text-center',
            thClass: 'text-center'
          }]
      }
    },
    methods: {
      addAgreement (value, workWith) {
        if (!value.target.checked) {
          this.selectedAgreements = this.selectedAgreements.filter(function (name) {
            return name !== workWith
          }).map(value => value)
        } else {
          this.selectedAgreements.push(workWith)
        }
        this.$emit('change', this.selectedAgreements)
        this.$forceUpdate()
      },
      getOrdinal (nextPayment) {
        if (nextPayment > 3 && nextPayment < 21) return nextPayment + 'th'
        switch (nextPayment % 10) {
          case 1: return nextPayment + 'st'
          case 2: return nextPayment + 'nd'
          case 3: return nextPayment + 'rd'
          default: return nextPayment + 'th'
        }
      }
    },
    computed: {
      selectAll: {
        get: function () {
          return this.selectedAgreements.length === this.eftAgreements.length
        },
        set: function (value) {
          this.selectedAgreements = []
          if (value) {
            this.selectedAgreements = this.eftAgreements.map(function (agreement) {
              return agreement.agreementId
            })
          }
          this.$emit('change', this.selectedAgreements)
          this.$forceUpdate()
        }
      },
      eftAgreements: {
        get: function () {
          if (!this.agreementData.firstName) {
            return []
          }
          let masterAgreement = _.map(this.agreementData.agreementEFTs, (agreement) => {
            const agreementData = _.cloneDeep(agreement)
            agreementData.memberName = StringUtils.initCaps(this.agreementData.firstName + ' ' + this.agreementData.lastName)
            agreementData.mainUser = true
            agreementData.autoBilled = 'x-' + agreementData.autoBilled.replace(new RegExp(/\*/g, 'g'), '')
            agreementData.renewal = this.getOrdinal(new Date(agreement.renewal).getDate())
            if (agreementData.cardExpirationDate) {
              agreementData.cardExpirationDate = new Date(agreementData.cardExpirationDate)
            }
            agreementData.selected = false
            return agreementData
          })
          let faoAgreements = _.map(this.agreementData.memberFaos, (owner) => {
            return _.map(owner.agreementEFTs, (agreement) => {
              const agreementData = _.cloneDeep(agreement)
              agreementData.memberName = StringUtils.initCaps(owner.firstName + ' ' + owner.lastName)
              agreementData.mainUser = false
              agreementData.autoBilled = 'x-' + agreementData.autoBilled.replace(new RegExp(/\*/g, 'g'), '')
              agreementData.renewal = this.getOrdinal(new Date(agreement.renewal).getDate())
              if (agreementData.cardExpirationDate) {
                agreementData.cardExpirationDate = new Date(agreementData.cardExpirationDate)
              }
              agreementData.selected = false
              return agreementData
            })
          })
          return masterAgreement.concat([].concat.apply([], faoAgreements))
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '~CommonBilling/css/variables';

  .payments-desc-header {
    font-family: "ApexMedium", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
    font-size: 18px;
    margin-top: 18px;
  }

  .payment-container .edit-form {
    padding: 10px 15px;
    background-color: #f5f5f5;
    margin: 0;
  }

  .overdue-card {
    color: red;
  }

  #payments-table .cc-sprite {
    display: inline-block;
    width:48px;
    height:30px;
    background: url(~CommonBilling/assets/cards-sprites-2x.png);
    background-position-y: 30px;
    zoom: 0.6;
    -moz-transform:scale(0.6);
    -moz-transform-origin: 0 0;
  }

  #payments-table .mc-cc-color{
    background-position-x: 0px;
  }

  #payments-table .dis-cc-color {
    background-position-x: 48px;
  }

  #payments-table .amx-cc-color{
    background-position-x: 96px;
  }

  #payments-table .visa-cc-color {
    background-position-x: 144px;
  }

  .controls-bottom {
    .info {
      color: #fff !important;
      margin: 0 !important;
    }
    .chevron {
      width: 8px !important;
      height: 0 !important;
      margin: 0px 5px !important;
      &.left::after {
        border-right: 6px solid #fff !important;
      }
      &.right::after {
        border-left: 6px solid #fff !important;
      }
    }

    select.browser-default option {
      color: black;
    }
    select.browser-default option:first-child {
      color: #fff;
    }
  }

  .controls-top {
    .info {
      margin: 0 !important;
    }
    .chevron {
      width: 8px !important;
      height: 0 !important;
      margin: 0px 5px !important;
    }
  }

  .datatable-length {
    margin-left: 10px;
  }

  .btn-print {
    background-color: transparent;
    border-radius: 0;
    padding: 5px 18px;
    border-color: #999;
    top: 15px;
  }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) {

    .billing-list-group {
      list-style: none;
      padding: 5px 0 5px 0;
      li {
        border-bottom: 1px solid #D5D2CA;
        border-bottom: 1px solid #D5D2CA;
        padding: 4px 0 4px 0;
        span {
          margin-left: 10px;
        }
      }
    }
    .billing-print {
      display: none;
    }
  }

  .billing-disable-link {
    cursor: not-allowed;
    backgroud-color: #F6F6F6 !important;
  }

  .validationError.is-danger {
    border-color: #ff3860;
  }

  /* Small devices (tablets, 768px and up) */
  @media (min-width: $screen-sm-min) {

    .billing-image-src {
      float: left !important;
      width: 100%;
      display: none;
    }

    span.is-focus {
      box-shadow: 0 0 0 2px lightblue;
    }

    .billing-list-group {
      list-style: none;
      padding: 5px 0 5px 0;
      li {
        border-bottom: 1px solid #D5D2CA;
        border-bottom: 1px solid #D5D2CA;
        padding: 10px 0;
        span {
          margin-left: 10px;
        }
      }
    }
  }

  /* Medium devices (desktops, 992px and up) */
  @media (min-width: $screen-md-min) {

    .billing-image-src {
      float: left !important;
      width: 100%;
      display: block;
    }

    .billing-list-group {
      list-style: none;
      padding: 5px 0 5px 0;
      li {
        border-bottom: 1px solid #D5D2CA;
        padding: 10px 0;
        span {
          margin-left: 10px;
        }
      }
    }
  }

  /* Large devices (large desktops, 1200px and up) */
  @media (min-width: $screen-lg-min) {
  }

  @media only screen and (max-width: 600px) {
  }

  @media only screen and (max-width: 750px) {
    .controls-top, .controls-bottom {
      .info {
        display: inline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/UpdatePaymentMethods/PaymentTable.vue